// // import { CiEdit } from "react-icons/ci";
// // import { AiFillEdit } from "react-icons/ai";
// // import profile_image from "../../assets/images/ajit_image.jpeg";
// // import styles from "./Profile.module.css";
// // import { Box } from "@mui/material";
// // import { useEffect, useState } from "react";

// // const ProfileBanner = () => {
// //     const [profileImage, setProfileImage] = useState(profile_image);
// //     const [banner, setBanner] = useState(null);
// //     const [buttonText, setButtonText] = useState("Change");
// //     const [selectedFileName, setSelectedFileName] = useState("");

// //     const handleImageChange = (e) => {
// //         const file = e.target.files[0];
// //         if (file) {
// //             const reader = new FileReader();
// //             reader.onloadend = () => {
// //                 setBanner(reader.result);
// //                 setButtonText("Change");
// //             };
// //             reader.readAsDataURL(file);
// //         }
// //     };

// //     const handleProfileChange = (e) => {
// //         const file = e.target.files[0];
// //         if (file) {
// //             const reader = new FileReader();
// //             reader.onloadend = () => {
// //                 setProfileImage(reader.result);
// //             };
// //             reader.readAsDataURL(file);
// //         }
// //     };

// //     const handleButtonClick = () => {
// //         document.getElementById("fileInput").click();
// //     };

// //     const handleFileChange = (event) => {
// //         const file = event.target.files[0];
// //         if (file) {
// //             setSelectedFileName(file.name);
// //         }
// //     };

// //     return (
// //         <div className="banner-upload-container" style={{ position: 'relative' }}>
// //             <div className="banner-frame">
// //                 {banner ? (
// //                     <img src={banner} alt="Banner" className="banner-image" />
// //                 ) : (
// //                     <div className="placeholder"></div>
// //                 )}
// //             </div>
// //             <input
// //                 type="file"
// //                 id="bannerInput"
// //                 accept="image/*"
// //                 onChange={handleImageChange}
// //                 style={{ display: "none" }}
// //             />
// //             <button
// //                 className="banner-button"
// //                 onClick={() => document.getElementById("bannerInput").click()}
// //             >
// //                 <AiFillEdit />
// //             </button>
// //             <div className={styles.banner_profile}>
// //                 <div className={styles.profile_image_wrapper}>
// //                     <img
// //                         id="profile-image"
// //                         src={profileImage}
// //                         alt="Profile"
// //                         className={styles.profile_image}
// //                     />
// //                     <div
// //                         className={styles.edit_icon}
// //                         onClick={() => document.getElementById("file-input").click()}
// //                     >
// //                         &#9998;
// //                     </div>
// //                 </div>
// //                 <input
// //                     type="file"
// //                     id="file-input"
// //                     accept="image/*"
// //                     style={{ display: "none" }}
// //                     onChange={handleProfileChange}
// //                 />
// //             </div>
// //         </div>
// //     );
// // };

// // export default ProfileBanner;
// import { AiFillEdit } from "react-icons/ai";
// import styles from "./Profile.module.css";
// import { useState } from "react";

// const ProfileBanner = ({
//   profileImage,
//   setProfileImage,
//   banner,
//   setBanner,
// }) => {
//   const [buttonText, setButtonText] = useState("Change");
//   const [selectedFileName, setSelectedFileName] = useState("");

//   // Convert Banner Image to Base64
//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setBanner(reader.result); // Set the banner image as Base64
//         setButtonText("Change");
//       };
//       reader.readAsDataURL(file); // Read the file as a data URL (Base64)
//     }
//   };

//   // Convert Profile Image to Base64
//   const handleProfileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfileImage(reader.result); // Set the profile image as Base64
//       };
//       reader.readAsDataURL(file); // Read the file as a data URL (Base64)
//     }
//   };

//   return (
//     <div className="banner-upload-container" style={{ position: "relative" }}>
//       <div className="banner-frame">
//         {banner ? (
//           <img src={banner} alt="Banner" className="banner-image" />
//         ) : (
//           <div className="placeholder"></div>
//         )}
//       </div>
//       <input
//         type="file"
//         id="bannerInput"
//         accept="image/*"
//         onChange={handleImageChange}
//         style={{ display: "none" }}
//       />
//       <button
//         className="banner-button"
//         onClick={() => document.getElementById("bannerInput").click()}
//       >
//         <AiFillEdit />
//       </button>
//       <div className={styles.banner_profile}>
//         <div className={styles.profile_image_wrapper}>
//           <img
//             id="profile-image"
//             src={profileImage}
//             alt="Profile"
//             className={styles.profile_image}
//           />
//           <div
//             className={styles.edit_icon}
//             onClick={() => document.getElementById("file-input").click()}
//           >
//             &#9998;
//           </div>
//         </div>
//         <input
//           type="file"
//           id="file-input"
//           accept="image/*"
//           style={{ display: "none" }}
//           onChange={handleProfileChange}
//         />
//       </div>
//     </div>
//   );
// };

// export default ProfileBanner;

import { AiFillEdit } from "react-icons/ai";
import styles from "./Profile.module.css";
import { useState } from "react";

const MAX_FILE_SIZE = 1048576; // 1MB in bytes

const ProfileBanner = ({
  profileImage,
  setProfileImage,
  banner,
  setBanner,
}) => {
  const [profileError, setProfileError] = useState("");
  const [bannerError, setBannerError] = useState("");

  const validateFileSize = (file, setError) => {
    if (file.size > MAX_FILE_SIZE) {
      setError("Max file size 1MB");
      return false;
    }
    setError("");
    return true;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && validateFileSize(file, setBannerError)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBanner(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfileChange = (e) => {
    const file = e.target.files[0];
    if (file && validateFileSize(file, setProfileError)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="banner-upload-container" style={{ position: "relative" }}>
      <div className="banner-frame" style={{ position: "relative" }}>
        {banner ? (
          <img src={banner} alt="Banner" className="banner-image" />
        ) : (
          <div className="placeholder"></div>
        )}
        <input
          type="file"
          id="bannerInput"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: "none" }}
        />
        <button
          className="banner-button"
          onClick={() => document.getElementById("bannerInput").click()}
        >
          <AiFillEdit />
        </button>

        {/* Banner Error Message */}
        {bannerError && (
          <div className={styles.banner_error_message}>{bannerError}</div>
        )}
      </div>

      <div className={styles.banner_profile}>
        <div className={styles.profile_image_wrapper}>
          <img
            id="profile-image"
            src={profileImage}
            alt="Profile"
            className={styles.profile_image}
          />
          <div
            className={styles.edit_icon}
            onClick={() => document.getElementById("file-input").click()}
          >
            &#9998;
          </div>
        </div>
        <input
          type="file"
          id="file-input"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleProfileChange}
        />
        {/* Profile Error Message */}
        {profileError && (
          <div className={styles.profile_error_message}>{profileError}</div>
        )}
      </div>
    </div>
  );
};

export default ProfileBanner;
